export default "__VITE_ASSET__Z0hIa9mK__"